export enum AgeRange {
    Child = 1,
    Junior,
    Teenager,
    Adult
}